import React from 'react';
import { api } from './api';
import { connect } from 'react-redux';
import { message, Modal, Form, Select, Col } from 'antd';
import queryString from 'query-string';

const FormItem = Form.Item;
class CambiarFletero extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabledLogin: false,
            fleteros: [],
        }
    }


    async componentDidMount() {
        this.fetch();
    }

    fetch = async () => {
        try {
            //FLETEROS
            const responseFlet = await api.fleteros.getAll(queryString.stringify({
                query: '',
            }))
            if (responseFlet.status === "success") {
                this.setState({
                    fleteros: responseFlet.data.fleteros,
                });
            } else {
                this.setState({
                    fleteros: [],
                });
                message.error(responseFlet.message, 5);
            }
        } catch (error) {
            message.error(error)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({
                        confirmLoading: true,
                    })

                    const response = await api.viajes.cambiarFletero({
                        numeroviaj:this.props.data.numeroviaj,
                        cproveviaj:values.fletero
                    })
                    if(response.status === "success"){
                        message.info("Fletero cambiado con exito")
                    }
                } catch (e) {
                    message.error(e.toString(), 7);
                }
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                visible={true}
                confirmLoading={this.state.confirmLoading}
                onOk={this.handleSubmit}
                onCancel={this.props.closeModal}
                cancelText="Cancelar"
                okText="Cambiar"
                width={600}
            >
                <section className="form-v1-container col-md-12">
                    <h4 style={{ marginBottom: 15 }}>Cambiar fletero</h4>
                    <Form style={{ marginTop: 10 }}>
                        <div className="row">
                            <Col span={24}>
                                <FormItem label="Fletero" {...{
                                    labelCol: { sm: { span: 4 }, },
                                    wrapperCol: { sm: { span: 16 }, },
                                }}>
                                    {getFieldDecorator('fletero', {
                                        initialValue: '',
                                        rules: [{ required: true, message: "Este campo es obligatorio" }],
                                    })(
                                        <Select
                                            // style={{ width: "65%" }}
                                            optionFilterProp="children"
                                            showSearch
                                            onChange={(e) => this.setState({ idfletero: e ? e : '' })}
                                            allowClear
                                            filterOption={(input, option) =>
                                                (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.state.fleteros && this.state.fleteros.map((data, index) => {
                                                return <Select.Option value={data.codigoflet} key={index}>{data.rasociflet}</Select.Option>
                                            })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>

                        </div>
                    </Form>
                </section>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const WrappedCambiarFletero = Form.create()(CambiarFletero);

export default connect(
    mapStateToProps,
)(WrappedCambiarFletero);